import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import ProtectedRoute from 'components/ProtectedRoute';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));

// render - color
const Color = Loadable(lazy(() => import('pages/component-overview/color')));
const Typography = Loadable(lazy(() => import('pages/component-overview/typography')));
const Shadow = Loadable(lazy(() => import('pages/component-overview/shadows')));

// render - sample page
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));

// render - sample page
const Usuarios = Loadable(lazy(() => import('pages/auth/usuarios')));
const Distritos = Loadable(lazy(() => import('pages/auth/distritos')));
const Socios = Loadable(lazy(() => import('pages/auth/socios')));
const Envios = Loadable(lazy(() => import('pages/auth/envios')));
const Bancos = Loadable(lazy(() => import('pages/auth/bancos')));
const TiposCreditos = Loadable(lazy(() => import('pages/auth/tipos_creditos')));
const Parentesco = Loadable(lazy(() => import('pages/auth/parentescos')));
const Pausas = Loadable(lazy(() => import('pages/auth/pausas')));
const Beneficiarios = Loadable(lazy(() => import('pages/auth/beneficiarios')));
const BeneficiariosCategoria = Loadable(lazy(() => import('pages/auth/beneficiarioscategoria')));
const MotivosCreditos = Loadable(lazy(() => import('pages/auth/MotivosCreditos')));
const Cuentas = Loadable(lazy(() => import('pages/auth/cuentas')));
const Creditos = Loadable(lazy(() => import('pages/auth/creditos')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <ProtectedRoute>
      <DashboardLayout />
    </ProtectedRoute>
  ),
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },
    {
      path: 'typography',
      element: <Typography />
    },
    {
      path: 'color',
      element: <Color />
    },
    {
      path: 'shadow',
      element: <Shadow />
    },
    {
      path: 'sample-page',
      element: <SamplePage />
    },
    {
      path: 'usuarios',
      element: <Usuarios />
    },
    {
      path: 'distritos',
      element: <Distritos />
    },
    {
      path: 'socios',
      element: <Socios />
    },
    {
      path: 'envios',
      element: <Envios />
    },
    {
      path: 'bancos',
      element: <Bancos />
    },
    {
      path: 'tipos_creditos',
      element: <TiposCreditos />
    },
    {
      path: 'parentescos',
      element: <Parentesco />
    },
     {
      path: 'pausas',
      element: <Pausas />
    },
     {
      path: 'beneficiarios',
      element: <Beneficiarios />
    },
     {
      path: 'beneficiarioscategoria',
      element: <BeneficiariosCategoria />
    },
     {
      path: 'motivoscreditos',
      element: <MotivosCreditos />
    },
     {
      path: 'cuentas',
      element: <Cuentas />
    },
    {
      path: 'creditos',
      element: <Creditos />
    }
  ]
};

export default MainRoutes;
